import type { HTMLAttributes, ReactNode } from 'react';

// PR-UX-08 atom · paper surface with hairline border.
// PR-UX-02 tokens · padding follows scale [16,24,32,48,64] via spacing utilities.

type Padding = 'tight' | 'normal' | 'loose';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: Padding;
  hover?: boolean;
  children: ReactNode;
}

const PADDING_CLASS: Record<Padding, string> = {
  tight: 'p-6',
  normal: 'p-8',
  loose: 'p-12',
};

export default function Card({ padding = 'normal', hover = false, className = '', children, ...rest }: CardProps) {
  return (
    <div
      className={`bg-paper border border-hairline rounded-lg transition-all ${PADDING_CLASS[padding]} ${hover ? 'hover:-translate-y-0.5 hover:shadow-[0_4px_16px_rgba(26,24,20,0.08)] hover:border-ash-300' : ''} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
